var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "radio" }, [
    _c("input", {
      ref: "radioBtn",
      attrs: { id: _vm.id, name: "radio", type: "radio" },
      domProps: { checked: _vm.checked, value: _vm.value },
      on: { input: _vm.handleBtnCheck }
    }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "radio-label", attrs: { for: _vm.id } },
      [_vm._t("default"), _vm._v("\n    " + _vm._s(_vm.text) + "\n  ")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e57d811", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e57d811","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/RadioButton.vue
// module id = null
// module chunks = 